<template>
  <div>
    <div class="row m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="row">
            <div class="form-group col-sm-12">
              <ul class="navbar-nav overflow-auto flex-row gap-4" >
                <li v-for="[tab, value] in visibleTabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap" >
                  <a href="#" @click.prevent="selectTab(value)" class="nav-link tab" :class="{'active': currentTab === value}">{{ helper.trans(`routing.tab.${tab}`) }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <MerchantStores v-if="currentTab === Tabs.stores"></MerchantStores>
      <ManualPriorities v-if="currentTab === Tabs.manualPriorities"></ManualPriorities>
      <TrafficGroups v-if="currentTab === Tabs.trafficGroups"></TrafficGroups>
      <AdditionalRewardSettings v-if="currentTab === Tabs.additionalRewardSettings"></AdditionalRewardSettings>
      <TraderPayoutPlans v-if="currentTab === Tabs.traderPayoutPlans"></TraderPayoutPlans>
      <RatesManagement v-if="currentTab === Tabs.ratesManagement"></RatesManagement>
    </div>
  </div>
</template>
<script lang="ts">
import {computed, defineComponent, toRefs, reactive} from 'vue'
import {useStore} from "vuex";
import {UserPermission} from "@/models/enum/UserPermission";
import {helper} from "@/service/CommonHelper";
import ManualPriorities from "@/views/ManualPriorities.vue";
import TrafficGroups from "@/views/TrafficGroups.vue";
import router from "@/router";
import {useRoute} from "vue-router";
import MerchantStores from "@/views/MerchantStores.vue";
import AdditionalRewardSettings from "@/views/AdditionalRewardSettings.vue";
import Providers from "@/views/Providers.vue";
import TraderPayoutPlans from "@/views/TraderPayoutPlans.vue";
import RatesManagement from "@/views/RatesManagement.vue";

enum Tabs {
  trafficGroups = 'traffic-groups',
  stores = 'stores',
  manualPriorities = 'manual-priorities',
  additionalRewardSettings = 'additional-reward-settings',
  traderPayoutPlans = 'trader-payout-plans',
  ratesManagement = 'rates-management',
}

export default defineComponent({
  components: {
    Providers,
    AdditionalRewardSettings,
    MerchantStores,
    TrafficGroups,
    ManualPriorities,
    TraderPayoutPlans,
    RatesManagement
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    const state = reactive({
      activeTabName: (route.params.tab ?? Tabs.trafficGroups) as Tabs,
    });

    const canManageRates = computed((): boolean => {
      return !!store.getters.isAdmin
        && !!store.getters.getAppData?.TRADER_RATES_BULK_EDIT_ENABLED
        && store.getters.hasPermission(UserPermission.EDIT_TRADER_RATES_BULK)
    })

    const visibleTabs = computed(() => {
      return Object.entries(Tabs).filter(([, value]) => value !== Tabs.ratesManagement || canManageRates.value)
    })

    const currentTab = computed((): Tabs => {
      if (state.activeTabName === Tabs.ratesManagement && !canManageRates.value) {
        return Tabs.trafficGroups
      }

      return state.activeTabName
    })

    const selectTab = async (value: string) => {
      router.push(`/admin/routing/${value}`)
      state.activeTabName = value as Tabs
    }

    return {
      ...toRefs(state),
      helper,
      Tabs,
      visibleTabs,
      currentTab,
      selectTab
    }
  }
})
</script>
